import type { Dispatch, SetStateAction } from 'react'
import React from 'react'
import { useContext } from '../../Context'
import { Toolbox } from '../Toolbox'
import { MainFilter } from './generateFilter'
import map from 'lodash/map'
import { Box, ShowIf } from '@ztechapps/webui.util'
import { CheckboxInput } from '@ztechapps/webui.input'
import { humanize } from '@ztechapps/common.utils'
import type { Template } from '@ztechapps/common.contract'
import { Stack } from 'react-bootstrap'

const mainFilter = new MainFilter()

export default ({ collapse }: { collapse: boolean; setCollapse: Dispatch<SetStateAction<boolean>> }) => {
  const { onFilter, reportFilters } = useContext()

  const onChange = (value: boolean, name: Record<any, any>, type: string) => {
    const filterValue = mainFilter?.run({ value, name, type })
    onFilter({
      template: {
        value: filterValue,
      } as Template,
    })
  }

  return (
    <Box>
      <Box.Header>
        <Stack>
          <div>
            <Toolbox />
          </div>
        </Stack>
      </Box.Header>
      <Box.Body>
        <div>
          <ShowIf condition={!collapse}>
            {map(reportFilters, (reportFilter, i) => {
              return (
                <div key={i} className="">
                  <div className="fw-bold"> {humanize(i)} </div>
                  {map(reportFilter, (item, index) => {
                    return (
                      <CheckboxInput
                        key={index}
                        label={item?.name}
                        onChange={(value) => {
                          onChange(value, item.value, 'category')
                        }}
                      />
                    )
                  })}
                </div>
              )
            })}
          </ShowIf>
        </div>
      </Box.Body>
    </Box>
  )
}
